// ── services/api/auth.api.ts ──────────────────────────────────────────────────
// All /auth/* calls.
// ────────────────────────────────────────────────────────────────────────────

import { api } from './client';

export interface AuthResponse {
  userId:        string;
  displayName:   string;
  token:         string;
  refreshToken:  string;
  activeTreeId?: string | null;
  claimedNodeId?: string;
  claimedTreeId?: string;
  claimError?:    string;
}

export interface SignupPayload {
  displayName: string;
  email:       string;
  password:    string;
  phoneNumber?: string;
}

export interface LoginPayload {
  email:    string;
  password: string;
}

export const authApi = {
  login:                 (payload: LoginPayload)  => api.post<AuthResponse>('/auth/login',  payload),
  signup:                (payload: SignupPayload) => api.post<AuthResponse>('/auth/signup', payload),
  logout:                (refreshToken?: string)  =>
    api.post<{ success: boolean }>('/auth/logout', refreshToken ? { refreshToken } : {}),
  refresh:               (refreshToken: string)   =>
    api.post<{ token: string; refreshToken?: string }>('/auth/refresh', { refreshToken }),
  verifyFirebaseToken:   (idToken: string, displayName?: string, inviteToken?: string) =>
    api.post<AuthResponse>('/auth/verify-firebase-token', { idToken, displayName, inviteToken }),
  verifyTruecallerToken: (payload: { requestId: string; accessToken: string; displayName?: string }) =>
    api.post<AuthResponse>('/auth/verify-truecaller', payload),
};
